// Utility function to convert Firebase error codes to user-friendly messages
export const getErrorMessage = (error) => {
  // Handle Firebase Auth errors
  if (error.code) {
    switch (error.code) {
      // Authentication errors
      case 'auth/user-not-found':
        return 'No account found with this email address.';
      case 'auth/wrong-password':
        return 'Incorrect password. Please try again.';
      case 'auth/invalid-email':
        return 'Please enter a valid email address.';
      case 'auth/user-disabled':
        return 'This account has been disabled. Please contact support.';
      case 'auth/too-many-requests':
        return 'Too many failed attempts. Please try again later.';
      case 'auth/operation-not-allowed':
        return 'This sign-in method is not enabled. Please contact support.';
      
      // Registration errors
      case 'auth/email-already-in-use':
        return 'An account with this email already exists. Please sign in instead.';
      case 'auth/weak-password':
        return 'Password is too weak. Please choose a stronger password.';
      case 'auth/invalid-credential':
        return 'Invalid email or password.';
      
      // Password reset errors
      case 'auth/user-not-found':
        return 'No account found with this email address.';
      case 'auth/invalid-email':
        return 'Please enter a valid email address.';
      
      // Network errors
      case 'auth/network-request-failed':
        return 'Network error. Please check your internet connection and try again.';
      case 'auth/timeout':
        return 'Request timed out. Please try again.';
      
      // General errors
      case 'auth/requires-recent-login':
        return 'Please sign in again to complete this action.';
      case 'auth/credential-already-in-use':
        return 'This account is already linked to another user.';
      case 'auth/invalid-verification-code':
        return 'Invalid verification code. Please try again.';
      case 'auth/invalid-verification-id':
        return 'Invalid verification ID. Please try again.';
      
      // Default case for unhandled error codes
      default:
        return 'An unexpected error occurred. Please try again.';
    }
  }
  
  // Handle non-Firebase errors or errors without codes
  if (error.message) {
    // If it's already a user-friendly message, return it
    if (error.message.includes('Please') || error.message.includes('account') || error.message.includes('password')) {
      return error.message;
    }
    // Otherwise, return a generic message
    return 'An unexpected error occurred. Please try again.';
  }
  
  // Fallback for any other error types
  return 'An unexpected error occurred. Please try again.';
};
